module.exports = __webpack_public_path__ + "media/flags/uy-6cdf73a4.svg";